import React, { useContext } from 'react';
import Map from './components/Map';
import { useResources } from './hooks/useResources';
import './styles/styles.scss';
import { TranslationContext } from './index';
import LoadingState from './components/common/LoadingState';
var App = function () {
    var _a = useResources(), resources = _a.resources, loading = _a.loading, error = _a.error;
    var translations = useContext(TranslationContext).translations;
    if (loading) {
        return (React.createElement("div", { className: "resource-map container" },
            React.createElement("div", { className: "map-container" },
                React.createElement(LoadingState, null))));
    }
    if (error) {
        return React.createElement("div", { className: "map-error" },
            translations.errorLoadingResources,
            " ",
            error.message);
    }
    return (React.createElement(Map, { resources: resources }));
};
export default App;
